import { initializeContainer, instance } from '../Utils/configuration';
import { setItem } from '../Utils/Storage';
import { APP_NAMES, Routes } from './routes';
import { STORAGE_KEYS } from '../Utils/constants';

// const VerifyFlow = (flow: string[]): boolean => {
//   return isMatchWith(Routes, flow, (r, f) => r.name.toLowerCase() === f.toLowerCase());
// };

export const ConvertFlow = (flow: string[]) => {
  // If the Flow is found invalid
  // if (!VerifyFlow(flow)) {
  //   console.error("Given Flow is invalid =>", flow);
  //
  // }

  // Converting the Flow into usable format
  const newFlow = [];
  flow.map((f, index) => {
    const newObject = {};

    newObject['previous'] = Routes.filter(
      (r) =>
        r.name.toLowerCase() ===
        (flow[index - 1]
          ? flow[index - 1].toLowerCase()
          : APP_NAMES.HOME.toLowerCase())
    )[0];

    newObject['current'] = Routes.filter(
      (r) => r.name.toLowerCase() === f.toLowerCase()
    )[0];

    newObject['next'] = Routes.filter(
      (r) =>
        r.name.toLowerCase() ===
        (flow[index + 1] ? flow[index + 1] : APP_NAMES.HOME).toLowerCase()
    )[0];

    newFlow.push(newObject);
  });
  return newFlow;
};

/*
 * oldHref is required for alternative(1)
 */
// let oldHref = document.location.href;
const FlowApiInitial = (flow: string[]) => {
  // Initializing the base Routing Data into the Container-app
  initializeContainer['routing'] = {
    route: () => ConvertFlow(flow),

    RouteUpdate: (data) => {
      initializeContainer['routing']['route'] = [
        ...initializeContainer['routing']['route'],
        ...data
      ];

      setItem(
        STORAGE_KEYS.ROUTE,
        JSON.stringify(initializeContainer['routing']['route'])
      );
      instance.emit('RouteUpdate', data);
    },

    getRoute: (appName) => {
      const route = JSON.parse(localStorage.getItem('route'));
      const filterBy = appName ? appName : APP_NAMES.HOME;
      const result = route.filter(
        (r) => r.current.name.toLowerCase() === filterBy.toLowerCase()
      )[0];

      return result;
    },

    goto: (pathname) => {
      history.pushState('', '', pathname);
      window.dispatchEvent(new PopStateEvent('popstate'));
    },

    goNext: (appName) => {
      const route = initializeContainer['routing'].getRoute(appName);
      initializeContainer['routing'].goto(route.next.link);
    },

    goPrevious: (appName) => {
      const route = initializeContainer['routing'].getRoute(appName);
      initializeContainer['routing'].goto(route.previous.link);
    },

    goHome: () => {
      const route = initializeContainer['routing'].getRoute(APP_NAMES.HOME);
      initializeContainer['routing'].goto(route.previous.link);
    }
  };
  setItem(STORAGE_KEYS.ROUTE, JSON.stringify(ConvertFlow(flow)));
};

export { FlowApiInitial };
